import { render, staticRenderFns } from "./DuplicateEventLogItem.vue?vue&type=template&id=0d71ee6e&scoped=true&"
import script from "./DuplicateEventLogItem.vue?vue&type=script&lang=js&"
export * from "./DuplicateEventLogItem.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateEventLogItem.vue?vue&type=style&index=0&id=0d71ee6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d71ee6e",
  null
  
)

export default component.exports